import { SheRavenClient } from './ravenClient';
import { SheEnv } from '../../commonv3/utils/envs';

declare const gtag: any;

export class ExperimentIds {
    static TRIAL_LP_TEST = '4bXGSwazS0uJNN47QmALCQ';
    static TRIAL_LP_TEST2 = 'htz3dP4_S7aLBcuauoOD8g';
    static SHECHAN_CTA_TEST = 'M7sqkUmdRAivL4VwWyBq2A';
    static SHECHAN_TOPPAGE_CTA_TEST = 'SqH8LHXrRnKu0mm75gRnJA';
    static LP_FOR_NEW_USER_TEST = 'oo9mEer1QS6f8Dtld5BjbQ';
    static GOAL_MANAGEMENT_TEST = 'iiIjM1CkRvaF9a81EsUe7g';
}

const TIMEOUT = 1000;

export class GoogleOptimizeClient {
    /**
     * Returns the variant id
     * It returns the control group '0' when the Google Optimize doesn't return response in 300ms
     * @param experimentId
     */
    static getVariantId(experimentId: string): Promise<string> {
        /**
         * テスト中は全てのABテストを無効にする
         * 特定のバケットに割り当てたい場合はURLでオーバーライドすること
         */
        if (SheEnv.isTest()) {
            return Promise.resolve('0');
        }
        try {
            if (!gtag) {
                throw new Error("Failed getting variant id: gtag doesn't exist");
            } else {
                return Promise.race<string>([
                    new Promise((resolve) => {
                        gtag('event', 'optimize.callback', {
                            name: experimentId,
                            callback: (value: string) => {
                                resolve(value);
                            },
                        });
                    }),
                    new Promise((resolve) => {
                        setTimeout(() => resolve('0'), TIMEOUT);
                    }),
                ]);
            }
        } catch (e) {
            SheRavenClient.captureException(e);
            return Promise.resolve('0');
        }
    }
}
